import { fetchContentGroupByName } from "../../api/contentGroups";
import { createSlice } from "@reduxjs/toolkit";

const contentGroupsSlice = createSlice({
    name: 'contentGroups',
    initialState: {
        groups: {}, // A dictionary to store multiple groups by name
        status: {}, // A dictionary to manage loading state for each group
        error: {} // A dictionary to track errors for each group
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContentGroupByName.pending, (state, action) => {
                const groupName = action.meta.arg;
                state.status[groupName] = 'loading';
                state.error[groupName] = null;
            })
            .addCase(fetchContentGroupByName.fulfilled, (state, action) => {
                const groupName = action.meta.arg;
                state.status[groupName] = 'succeeded';
                state.groups[groupName] = action.payload?.items;
            })
            .addCase(fetchContentGroupByName.rejected, (state, action) => {
                const groupName = action.meta.arg;
                state.status[groupName] = 'failed';
                state.error[groupName] = action.payload;
            });
    }
});

export default contentGroupsSlice.reducer;
